import { STAFF_ROLES } from './constants'

const normalizeRole = (role?: string | null) => role?.trim().toLowerCase() ?? ''

export const isFieldAgent = (role?: string | null) =>
    normalizeRole(role) === STAFF_ROLES.FIELD_AGENT

export const isVeLikeRole = (role?: string | null) =>
    normalizeRole(role) === STAFF_ROLES.VE.toLowerCase()

export const isFcLikeRole = (role?: string | null) => {
    const normalized = normalizeRole(role)
    return (
        normalized === STAFF_ROLES.FC.toLowerCase() ||
        normalized === STAFF_ROLES.FIELD_AGENT ||
        normalized === STAFF_ROLES.POULTRY_AGENT
    )
}

export const getStaffRouterKey = (role?: string | null) => {
    if (isFcLikeRole(role)) {
        return STAFF_ROLES.FC
    }
    if (isVeLikeRole(role)) {
        return STAFF_ROLES.VE
    }
    return role
}

export const getFcLikeProfileTitleKey = (role?: string | null) => {
    const normalized = normalizeRole(role)
    if (normalized === STAFF_ROLES.POULTRY_AGENT) {
        return 'fcProfile.poultryAgentTitle'
    }
    if (normalized === STAFF_ROLES.FIELD_AGENT) {
        return 'fcProfile.fieldAgentTitle'
    }
    return 'fcProfile.fcTitle'
}
